class MegaMenuOpener extends HTMLElement {
  constructor() {
    super();

    this.closeTimeout = null;
    this.openTimeout = null;
    this.details = this.querySelector("details");
    this.summary = this.querySelector("summary");
    this.content = this.querySelector("[data-mega-menu-content]");

    this.lastMousePosition = null;

    if (!this.clickOnly) {
      this.handleMousemove = (e) => {
        this.newMousePosition = {
          y: e.pageY,
          time: Date.now(),
        };

        if (this.lastMousePosition) {
          this.velocity =
            (this.newMousePosition.y - this.lastMousePosition.y) /
            (this.newMousePosition.time - this.lastMousePosition.time);
        }

        this.lastMousePosition = this.newMousePosition;
      };

      document.addEventListener("mousemove", this.handleMousemove);

      this.addEventListener("mouseover", () => {
        if (!isFinite(this.velocity)) return;

        if (Math.abs(this.velocity) > 0.1) {
          if (this.openTimeout) return;

          this.openTimeout = setTimeout(() => {
            this._open();
          }, 100);
        } else {
          this._open();
        }
      });

      this.addEventListener("mouseleave", () => {
        this._close();
      });
    }

    this.content.addEventListener("focusout", (e) => {
      if (this.content.contains(e.relatedTarget)) return;

      this._close();
    });

    this.addEventListener("click", (e) => {
      if (this.summary.contains(e.target) && !e.target.closest("a")) {
        e.preventDefault();
        this.details.open ? this._close() : this._open();
      }
    });

    this.closeEsc = (e) => {
      if (e.key === "Escape" && this.details.open) {
        this._close();
        this.summary.focus();
      }
    };

    document.addEventListener("keydown", this.closeEsc);

    // const handleOtherMenuClose = (e) => {
    //   if (e.target == this) return;

    //   this._close(true);
    // };

    // document.addEventListener('menu:open', handleOtherMenuClose);
  }

  disconnectedCallback() {
    document.removeEventListener("keydown", this.closeEsc);
    document.removeEventListener("mousemove", this.handleMousemove);
    // document.removeEventListener('menu:open', handleOtherMenuClose);
  }

  get _shouldPushDownContent() {
    return !document.body.classList.contains("header--sticking");
  }

  get clickOnly() {
    return this.hasAttribute("click-only");
  }

  get setBackground() {
    return this.hasAttribute("set-bg");
  }

  _open() {
    clearTimeout(this.closeTimeout);
    clearTimeout(this.openTimeout);
    if (this.details.classList.contains("open")) return;
    window.openDimmer(this);
    window.lockScroll(this);
    this.removeEventListener("transitionend", this.onEnd);
    this.openTimeout = null;
    this.details.open = true;
    this.details.classList.add("open");
    this.dispatchEvent(new CustomEvent("menu:open", { bubbles: true }));

    if (this.setBackground) {
      document.documentElement.style.setProperty(
        "--header-background",
        "var(--color-light-grey)",
      );
    }

    this.content.style.height = 0;
    this.content.style.overflow = "hidden";

    this.onEnd = (e) => {
      if (e.target !== this.content) return;

      this.removeEventListener("transitionend", this.onEnd);
      this.content.style.height = null;
      this.content.style.overflow = "auto";
    };

    this.addEventListener("transitionend", this.onEnd);

    window.requestAnimationFrame(() => {
      const height = this.content.scrollHeight;
      this.content.style.height = `${height}px`;
      if (this._shouldPushDownContent) {
        document.documentElement.style.setProperty(
          "--mega-menu-height",
          `30px`,
        );
      }
    });
  }

  _close(force) {
    clearTimeout(this.closeTimeout);
    clearTimeout(this.openTimeout);

    this.removeEventListener("transitionend", this.onEnd);
    this.openTimeout = null;

    this.closeTimeout = setTimeout(
      () => {
        const height = this.content.scrollHeight;
        this.content.style.height = `${height}px`;

        window.requestAnimationFrame(() => {
          this.dispatchEvent(new CustomEvent("menu:close", { bubbles: true }));
          window.closeDimmer(this);
          window.unlockScroll(this);
          document.documentElement.style.removeProperty("--header-background");

          this.onEnd = (e) => {
            if (e.target !== this.content) return;
            this.removeEventListener("transitionend", this.onEnd);

            if (this.classList.contains("open")) return;
            this.details.open = false;
            document.documentElement.style.removeProperty("--mega-menu-height");
            this.content.style.height = null;
            this.content.style.overflow = null;
          };
          this.addEventListener("transitionend", this.onEnd);
          this.details.classList.remove("open");
          const header = this.closest(".header");
          this.content.style.height = 0;
          this.content.style.overflow = "hidden";
          document.documentElement.style.setProperty(
            "--mega-menu-height",
            `0px`,
          );
        });
      },
      force ? 0 : 250,
    );
  }
}

if (!customElements.get("mega-menu-opener")) {
  customElements.define("mega-menu-opener", MegaMenuOpener);
}
